import assetsManager from "../assets/assetsmanager/assestsmanager";
import FolderDropzone from "../component/Dropzone";
import { AppContext } from "../context/context";
import { uploadPdf } from "../hooks/uploadPdf";
import React, { useContext, useState } from "react";
import toast from "react-hot-toast";

const UploadPdfModal = ({ setUploadPdfModalOpen }) => {
  //global state
  const { fetchDocuments, state } = useContext(AppContext);
  const { pdfData } = state;

  //Selected pdfs
  const [files, setFiles] = useState([]);

  //loading state to disable events
  const [loading, setLoading] = useState(false);

  // handle submmit  selected pdfs
  const handleSubmit = async () => {
    let toastId = toast.loading("loading...");
    setLoading(true);
    // fetching unique file names in a array from pdf list
    const uniqueNamesInB = new Set(pdfData.map((obj) => obj.name));

    //filtering pdf for non existing files or files with unique names so files should not overrides or replaces
    const selectedFiles = files.filter((obj) => !uniqueNamesInB.has(obj.name));
    //filtering files that are repeated or already exist in table
    const unSelectedFiles = files.filter((obj) => uniqueNamesInB.has(obj.name));
    //
    if (selectedFiles.length > 0) {
      // uploading files in a loop one by one
      for (const file of selectedFiles) {
        try {
          let data = await uploadPdf(file, state?.activeTab);
          if (data.status === "Docs uploaded successfully.") {
            toast.dismiss(toastId);
            toast.success(`PDF (${file?.name}) uploaded successfully.`);
          } else {
            toast.error(`PDF (${file?.name}) ${data.status}`);
          }
        } catch (err) {
          console.log("Error: ", err);
          toast.dismiss(toastId);
          toast.error(err);
        }
      }
    } else {
      toast.dismiss(toastId);
    }
    unSelectedFiles.forEach((file) => {
      toast.error(
        `File with this name already exists. Please upload it again with another name.
          ${file.name}`,
        {
          duration: 12000,
          position: "top-center"
        }
      );
    });

    // toggle loading state
    setLoading(false);

    //closing modal
    setUploadPdfModalOpen(false);

    //refetching documents
    fetchDocuments(state?.activeTab);
  };

  //handle close modal
  const handleClose = () => {
    setUploadPdfModalOpen(false);
  };

  //handle remove / unselect files
  const handleRemoveFile = (i) => {
    setFiles((prev) => prev.filter((file, index) => i !== index));
  };

  return (
    <div className="uploadPdfModal flex items-center justify-center h-full w-screen absolute inset-0 bg-[grey] z-[1] bg-opacity-50">
      <div className="modal bg-white rounded-md p-6 w-[30rem] relative">
        <div
          onClick={handleClose}
          className="w-7 h-7 p-2 absolute top-[8px] right-[15px] cursor-pointer"
        >
          <img className="h-full w-full" src={assetsManager.crossIcon} alt="" />
        </div>
        <div className="modal-header text-center text-xl text-[#424242] font-medium">
          Upload PDFs
        </div>
        <div className="modal-body">
          <div className="dropZone mt-5">
            <FolderDropzone
              multiSelect={true}
              files={files}
              setFiles={setFiles}
            />
          </div>
          {files.length > 0 && (
            <div className="filesList mt-2">
              <p className="text-[#676767] font-medium text-md">Uploading</p>
              <ul className="mt-1 flex flex-col gap-2 max-h-[8rem] overflow-auto">
                {files?.map((file, i) => (
                  <li
                    className="border-[0.5px] border-[#E3E3E3] text-sm flex items-center justify-between p-2 rounded-[4px]"
                    key={file.name}
                  >
                    <p>{file.name}</p>
                    <img
                      className="cursor-pointer"
                      onClick={() => handleRemoveFile(i)}
                      src={assetsManager.crossIconForUploadFile}
                      alt=""
                    />
                  </li>
                ))}
              </ul>
            </div>
          )}
          <button
            className="bg-[#C7222A] text-white text-sm flex items-center justify-center w-full h-[39px] mt-3 rounded-[4px] disabled:cursor-not-allowed"
            onClick={handleSubmit}
            disabled={files?.length === 0 || loading}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default UploadPdfModal;
